// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cloud: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58 39"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M50.5 20.5C50 9.4 41.2.4 30.8.4c-9.2 0-17.6 6.9-19.6 16h-.6C4.9 16.4.4 21.4.4 27.5c0 6.3 4.4 11.2 9.9 11.2h39c4.6 0 8.2-4 8.2-9.1.2-4.7-2.9-8.6-7-9.1zm-1.1 2.2c3.3 0 5.9 3 5.9 6.8s-2.6 6.8-5.9 6.8h-39c-4.3 0-7.8-3.9-7.8-8.8s3.6-8.9 8.1-8.9h2.4l.1-.9c1.5-8.6 9-15.1 17.6-15.1 9.6 0 17.5 8.5 17.5 18.9v1.2h1.1z"/></svg>;
};

export default React.memo(Cloud);
